<template>

  <div 
    class="email-area"
    :class="{'box-loading': loading}">
    
    <no-results
      v-if="!email._id">
      {{ $t('Select an email') }}
      </no-results>

    <div v-if="email._id">
      <div
        v-if="email.candidate_id"    
        class="header mb-3">
        <div class="d-flex align-items-center">
          <div
            class="mr-3">
            <Avatar
              :src="imgSrc"
              :name="email.candidate_id.name"
              size="40px"
              radius="20px"
              resize="100x100x1" />
          </div>
          <div class="w-100">
            <h5>
              <router-link
                :to="toRouteCandidate">
                {{ email.candidate_id.name }}
                </router-link>
            </h5>
            <h6>
              <router-link
                :to="{path: '/job/' + email.job_id._id }">
                {{ email.job_id.title }}
                </router-link>
            </h6>
          </div>
        </div>
      </div>

      <div class="card">

        <div class="card-body">
          <div v-if="!newMail">

            <div class="mb-4">
              <email-actions
                style="float:right"
                :value="email"
                @create="createEmail"
                @delete="deleteEmail">
                </email-actions>
              <strong>{{ email.subject }}</strong>
            </div>

            <div
              class="alert alert-danger"
              v-if="email.delivery_notification === 'bounce'">
              <b>Message not delivered.</b> There was a problem delivering your message.
            </div>
            <div
              class="alert alert-danger mt-2"
              v-if="email.delivery_status === 'failed'">
              <b>Your message was not sent.</b> An error occurred while trying to send your message
            </div>

            <div>
              <div style="float: right;">
                <small>{{ $d(new Date(email.created_at), 'short') }}</small>
              </div>
              <div>
                De 
                <i
                  v-if="email.from"
                  v-tooltip="email.from.email">
                  {{ email.from.name }}
                </i>
              </div>
              <div
                v-if="email.to">
                Para
                <i>
                  <span
                    v-for="(item, index) in email.to"
                    :key="index"
                    v-tooltip="item.email">
                    {{ item.name }}{{ index + 1 < email.to.length ? ', ' : '' }}
                  </span>
                </i>
              </div>
              <div
                v-if="email.cc && email.cc.length">
                Cópia para
                <i>
                  <span
                    v-for="(item, index) in email.cc"
                    :key="index"
                    v-tooltip="item.email">
                    {{ item.name }}{{ index + 1 < email.cc.length ? ', ' : '' }}
                  </span>
                </i>
              </div>
              <div
                v-if="email.bcc && email.bcc.length">
                Cópia oculta para
                <i>
                  <span
                    v-for="(item, index) in email.bcc"
                    :key="index"
                    v-tooltip="item.email">
                    {{ item.name }}{{ index + 1 < email.bcc.length ? ', ' : '' }}
                  </span>
                </i>
              </div>

              <div
                class="mt-2 text-warning"
                v-if="email.delivery_status === 'scheduled'">
                <i class="fas fa-clock" /> <b>{{ $d(new Date(email.send_at), 'long') }}</b>
              </div>
            </div>
            
            <hr>

            <HtmlFrame
              :html="email.body"
              :url="email.body_media ? email.body_media.url : null" />
            
            <div
              class="mt-4"
              v-if="email.attachments_media.length">
              <div class="attachments-list">
                <a 
                  v-for="(file, index) in email.attachments_media"
                  :key="index"
                  :href="file.url"
                  target="_blank">
                  <i class="fas fa-paperclip" />
                  {{ $subString(file.title, 40) }}
                </a>
              </div>
            </div>

          </div>

          <email-form
            v-if="newMail"
            :initValue="newMail"
            @created="createdEmail"
            @cancel="cancelEmail">
            </email-form>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import config from '@/config'
import EmailForm from '../Email/EmailForm'
import EmailActions from '../Email/EmailActions'
import HtmlFrame from '@/components/Fields/HtmlFrame'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'emailItem',
  props: [
  ],
  components: {
    EmailForm,
    EmailActions,
    HtmlFrame,
    Avatar
  },
  data () {
    return {
      loading: false,
      newMail: false
    }
  },
  computed: {
    emailId () {
      return this.$route.query.email_id
    },
    email () {
      return this.$store.getters.getEmail
    },
    toRouteCandidate () {
      return {
        query: {
          ...this.$clone(this.$route.query),
          candidate_id: this.email.candidate_id._id,
          candidate_job_id: this.email.job_id._id
        }
      }
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.email.candidate_id.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  watch: {
    emailId (value) {
      if (value) this.loadData()
    }
  },
  created () {
    if (this.emailId) {
      this.loadData()
    }
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      this.$store
      .dispatch('selectEmail', this.emailId)
      .then((result) => {
        this.$store.dispatch('updateEmailRead', {
          _id: result._id,
          read: true
        })
        this.loading = false
        this.newMail = false
      })
    },
    /*
    createEmail
    */
    createEmail (data) {
      this.newMail = data
    },
    /*
    cancelEmail
    */
    cancelEmail () {
      this.newMail = false
    },
    /*
    deleteEmail
    */
    deleteEmail (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteEmail', id)
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
          this.$store.dispatch('refreshSelectEmails')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    /*
    createdEmail
    */
    createdEmail () {
      this.newMail = false
      this.$store.dispatch('refreshSelectEmails')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .email-area{
    padding: 1em;
    background: rgba(0,0,0,0.1);
    min-height: 100%;
  }

.header {
  align-items: center;
  border-radius: 3px;
}
  .header img {
    border-radius: 20px;
    width: 40px;
    height: 40px;
  }
  .header h5,
  .header h6{
    margin: 0.2em 0;
  }
  .header h5 a{
    color: inherit;
  }
  .header h6 a{
    color: rgba(0,0,0,0.6);
  }
</style>



// WEBPACK FOOTER //
// src/components/Email/EmailContent.vue